// extracted by mini-css-extract-plugin
module.exports = {"value":"ContactItemControl_value__17Ja1"};